<template>
  <div>
    <div class="search" style="margin:20px 0 0 0;">
      <el-form class="searchForm" :inline="true" ref="form" :rules="rule" :model="form" style="padding:0">
        <el-form-item label="加点方案名称" prop="NAME">
          <el-input size="medium" v-model="form.NAME" style="vertical-align:middle"></el-input>
        </el-form-item>
        <el-form-item  label="默认加点" prop="SCHEME_POINT">
          <el-input size="medium" v-model="form.SCHEME_POINT" style="vertical-align:middle"><template slot="append">%</template></el-input>
        </el-form-item>
        <el-form-item  label="是否为缺省方案" prop="BE_DEFAULT">
          <el-checkbox size="medium" v-model="form.BE_DEFAULT"></el-checkbox>
        </el-form-item>
        <el-form-item label="" prop="ADD_ONE">
          <el-button size="medium" @click="addOneClassify">新增一级大类</el-button>
        </el-form-item>
        <el-form-item  label="" prop="ADD_TWO">
          <el-button size="medium" @click="addTwoClassify">新增二级大类</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="middle">
      <el-button style="margin-left: 20px" size="medium" @click="handleUpdate('form')">提交</el-button>
    </div>
    <div style="background:white;border-radius:3px;margin-top:10px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane v-for="(item, index) in treeData" :label="item.CATEGORY_NAME" :key="item.CATALOG_CODE"
          style="height:500px;overflow-y:auto">
          <el-row>
            <el-col>
              <el-form>
                <el-form-item label="快速设置点数:" prop="SCHEME_POINT">
                  <span style="width: 100px;"></span>
                  <el-input size="medium" v-model="item.POINT" style="width: 200px"><template
                      slot="append">%</template></el-input>
                  <el-button size="medium" style="width:80px" @click="handleRapidSet(index)">设置</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row style="overflow-x: auto">
            <el-table :data="item.children" border stripe>
              <el-table-column prop="CATEGORY_NAME" label="二类"></el-table-column>
              <el-table-column prop="POINT" label="加点">
                <template slot-scope="scope">
                  <el-input size="medium" v-model="scope.row.POINT" style="width:150px;margin-top: 0"><template
                      slot="append">%</template></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="priceAddPoint(scope.row)">价格区间加点</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- //新增一级大类弹出框 -->
    <el-dialog title="新增一级大类" :visible.sync="addOneVisible" center width="400px">
      <el-form :model="addOne" label-width="100px">
        <el-form-item label="一级大类：">
          <el-select filterable v-model="addOne.Classify" placeholder="请选择一级大类" clearable>
            <el-option v-for="item in addOneList" :key="item.INNER_CODE" :label="item.NAME"
              :value="item.INNER_CODE"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addOneVisible = false">取消</el-button>
        <el-button type="primary" @click="submitOne">确定</el-button>
      </div>
    </el-dialog>

    <!-- //新增二级大类弹出框 -->
    <el-dialog title="新增二级大类" :visible.sync="addTwoVisible" center width="400px">
      <el-form :model="addTwo" label-width="100px">
        <el-form-item label="二级大类">
          <el-select filterable v-model="addTwo.Classify" placeholder="请选择二级大类" clearable>
            <el-option v-for="item in addTwoList" :key="item.INNER_CODE" :label="item.NAME"
              :value="item.INNER_CODE"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addTwoVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTwo">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      // loading: false,
      addOne: {},
      addTwo: {},
      formLabelWidth: '120px',
      addOneVisible: false,
      addTwoVisible: false,
      addOneList: [],
      addTwoList: [],
      tableData: [],

      form: {
        NAME: '',
        BE_DEFAULT: false,
        SCHEME_POINT: '',
      },
      rule: {
        NAME: [{ required: true, message: '请输入方案名称', trigger: 'blur' }],
        SCHEME_POINT: [{ required: true, message: '请输入加点级别', trigger: 'blur' }],
      },
      treeData: [],
      activeName: '',
      rapidSet: 6,
    };
  },
  methods: {
    // 查询一级大类
    addOneClassify() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 11,
        SCHEME_ID: this.$route.params.SCHEME_ID,
      };
      http
        .post(params)
        .then((result) => {
          this.addOneList = result;
          this.addOneVisible = true;
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 查询二级大类
    addTwoClassify() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 13,
        SCHEME_ID: this.$route.params.SCHEME_ID,
      };
      http
        .post(params)
        .then((result) => {
          this.addTwoVisible = true;
          this.addTwoList = result;
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 新增一级大类
    submitOne() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 12,
        SCHEME_ID: this.$route.params.SCHEME_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        FIRST_CATEGORIES_IDS: [this.addOne.Classify],
      };
      if (!this.addOne.Classify) {
        this.$message.show({ text: '请选择一级大类', type: 'warning' });
        return false;
      }
      http
        .post(params)
        .then((result) => {
          this.addTwoVisible = false;
          this.queryUpdateProductCatalog();
          this.addOne = {};
          this.$message.show({ text: '更新成功', type: 'success' });
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 新增二级大类
    submitTwo() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 14,
        SCHEME_ID: this.$route.params.SCHEME_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SECOND_CATEGORIES_IDS: [this.addTwo.Classify],
      };
      if (!this.addTwo.Classify) {
        this.$message.show({ text: '请选择二级大类', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.addTwoVisible = false;
        this.queryUpdateProductCatalog();
        this.addTwo = {};
        this.$message.show({ text: '更新成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleUpdate() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10023',
            OTYPE: 9,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            SCHEME_NAME: this.form.NAME,
            DEFAULT_POINT: this.form.SCHEME_POINT,
            BE_DEFAULT: Number(this.form.BE_DEFAULT),
            SCHEME_DATA: this.treeData,
            SCHEME_ID: this.$route.params.SCHEME_ID,
          };
          const flag1 = this.treeData.find((item) => {
            const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
            if (!reg.test(item.POINT)) {
              return true;
            }
          });
          if (flag1) {
            this.$message.show({ text: '请输入正数加点', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          http.post(params).then((result) => {
            this.queryUpdateProductCatalog();
            this.$message.show({ text: '更新成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    queryUpdateProductCatalog() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 8,
        SCHEME_ID: this.$route.params.SCHEME_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.treeData = result[0].DETAIL.length > 0 ? result[0].DETAIL : [];
        this.form.NAME = result[0].SCHEME_NAME;
        this.form.BE_DEFAULT = Boolean(result[0].BE_DEFAULT);
        this.form.SCHEME_POINT = result[0].DEFAULT_POINT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleRapidSet(index) {
      this.$confirm('该操作会更改当前大类下所有加点数，确定么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.treeData[index].children.forEach((children) => {
          this.$set(children, 'POINT', this.treeData[index].POINT);
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    priceAddPoint(row) {
      sessionStorage.setItem('priceAddPoint-SCHEME_ID', this.$route.params.SCHEME_ID);
      this.$router.push({
        name: 'priceRangePlus',
        params: {
          CATALOG_CODE: row.CATALOG_CODE,
        },
      });
    },
  },
  mounted() {
    this.queryUpdateProductCatalog();
  },
};
</script>

<style scoped>
.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding-left: 20px;
  margin: 0 -20px 0 -20px;
}

.search {
  width: 100%;
}

.searchForm {
  background: white;
  border-radius: 3px;
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/updateAddPrice.vue